import { render, staticRenderFns } from "./DrawUp.vue?vue&type=template&id=8ebd9bc0&scoped=true"
import script from "./DrawUp.vue?vue&type=script&lang=js"
export * from "./DrawUp.vue?vue&type=script&lang=js"
import style0 from "./DrawUp.vue?vue&type=style&index=0&id=8ebd9bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebd9bc0",
  null
  
)

export default component.exports